import * as React from "react";

const SvgArrowRight = props => <svg viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.501 10.985L0.534001 10.018L5 5.5L5 5.49599L0.526001 0.985L1.5 0.0109996L6.989 5.49599L1.501 10.985Z" fill="#343A40" /></svg>;

export default SvgArrowRight;